export const ROUTES = {
    root: {
        url: '/',
        title: 'Felice Livestream',
    },
    confirmLivestream: {
        url: '/chot-don-livestream',
        title: 'Chốt đơn livestream',
    },
    order: {
        url: '/dat-hang',
        title: 'Đặt hàng',
    },
};
